import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import answerimg from '../../images/answer.png'
import s from '../../services/allservices.jsx'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../stylesheet/changepassword.css'
import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux';
import LoaderSmall from "../loader/loader.jsx"
import $ from 'jquery'

const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        secretQues: state.secretQuesReducer.secretQues,
    })

const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        fetchSecretQues(quesReceived) {
            dispatch(
                actions.secretQuesAction(quesReceived)
            )
        }
    })

const JSEncrypt = window.JSEncrypt
class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            secret: "",
            value: null,
            oldPassword: "",
            newPassword: "",
            currentPassword: "",
            correctPassword: true,
            secretAnswer: "",
            secretQuestionCode: "FF",
            correctDob:true

        }
    }
    componentDidMount() {
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") == "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
        this.props.fetchSecretQues(false)
    }

    handleSelect = (event, index, value) => {
        let _this= this
        this.findDescription(value)
        this.setState({ 
            value 
        }, () => {
            console.log(_this.state.value)
            _this.setState({
                // secAnsDisabled: false,
                correctDob:true
            })
        });
    }
    handelepassword = (e, value) => {
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "newPassword") {
            if (passwd.test(e.target.value)) {
                this.setState({
                    correctPassword: true,
                    newPassword: value,
                    disabled: false,
                })
            } else {
                this.setState({
                    correctPassword: false,
                    disabled: true,
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }
    removepassword = () => {
        this.setState({
            correctPassword: true
        })
    }
    findDescription(value) {
        const { secretQues } = this.props
        for (let i = 0; i < secretQues.body.length; i++) {
            if (secretQues.body[i].secretQuestionCode === value) {
                this.setState({ description: secretQues.body[i].description })
            }
        }
    }
    onChange = (e, value) => this.setState({ [e.target.name]: e.target.value }, () => {

    })

    onChangeSecAns=(e, ansValue)=>{
        let _this = this
        if (this.state.value === "DOB") {
            console.log("inside dob")
            console.log(_this.state.secretAnswer)
            var dobFormat = new RegExp(/^\s*(3[01]|[12][0-9]|0[1-9])\/(1[012]|0[1-9])\/((?:19|20)\d{2})\s*$/)
            if (dobFormat.test(ansValue)) {
                this.setState({
                    [e.target.name]: ansValue,
                    correctDob: true
                }, () => {
                    console.log(_this.state.secretAnswer)
                    if (_this.state.secretAnswer.length > 0) {
                        _this.setState({
                            // secAnsSubmit: false,

                        })

                    }
                    else {
                        _this.setState({
                            // secAnsSubmit: true
                        })
                    }
                })
            }
            else {
                this.setState({
                    correctDob: false,
                    // secAnsSubmit: true
                })
            }
        }
        else {
            console.log("else")
            this.setState({
                [e.target.name]: ansValue,
                correctDob: true
            }, () => {
                console.log(_this.state.secretAnswer)
                if (_this.state.secretAnswer.length > 0) {
                    _this.setState({
                        // secAnsSubmit: false,
                        correctDob: true
                    })

                }
                else {
                    _this.setState({
                        // secAnsSubmit: true,
                        correctDob: true
                    })
                }
            })
        }
    }

    changeSecretQuestion() {
        const { currentPassword } = this.state
        let state = {
            accountId: localStorage.getItem('accountId'),
            applicationId: "gmcabs",
            currentPassword: this.state.currentPassword,
            secretPassword: this.state.secretAnswer,
            secretQuestionCode: this.state.value
        }
        let token = "Token " + localStorage.getItem('token')
        if (currentPassword !== '') {
            this.setState({
                loader: true
            })
            fetch(s.change_seq_que, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        this.setState({
                            loader: false
                        })
                        setTimeout(function () { window.location.reload(true); }, 2000);
                    } else if (response.status === 400 || response.status === 401) {
                        toast.error('Please Login again'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        }
                        this.setState({
                            loader: false
                        })

                    }
                    else {
                        this.setState({
                            loader: false
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });

                    }
                })
        } else {
            toast.error('Please enter data in required fields'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            }
        };

    }

    handleSubmit = () => {
        const { oldPassword, newPassword, confirmPassword, correctPassword } = this.state
        let _this = this
        const { publicKey } = this.props
        if (correctPassword === false) {
            this.setState({
                correctPassword: false,
            })
        }
        else {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let _this = this


                const state = {
                    applicationId: "gmcabs",
                    confirmPassword: encrypt.encrypt(confirmPassword),
                    newPassword: encrypt.encrypt(newPassword),
                    oldPassword: encrypt.encrypt(oldPassword),
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                if (newPassword !== "" && oldPassword !== "" && confirmPassword !== "") {

                    let token = "Token " + localStorage.getItem('token')
                    if (newPassword === confirmPassword) {
                        this.setState({
                            loader: true
                        })
                        fetch(s.change_password, {
                            method: 'POST',
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }),
                            body: JSON.stringify(state)
                        })
                            .then(response => {
                                if (response.status === 200 || response.status === 201) {
                                    toast.success(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });
                                    this.setState({
                                        loader: false
                                    })
                                    setTimeout(function () { window.location.reload(true); }, 3000);
                                } else {
                                    toast.error(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });
                                    this.setState({
                                        loader: false
                                    })

                                }
                            })
                    } else {
                        toast.error('New Password and Confirm Password should be same'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        };

                    }
                } else {
                    toast.error('Please enter data in required fields'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };

                }
            }
        }
    }
    render() {
        const { secretQues } = this.props
        const { correctPassword,correctDob } = this.state
        return (
            <div style={{ padding: "0px 30px" }}>


                <div className="col-md-12" >
                    {this.state.loader ? <div style={{ marginTop: "200px" }}><LoaderSmall /></div> :
                        <div className="row">

                            <div className="tile box-shadow-style" >
                                <div className="row">

                                    <div className="col-md-12">
                                        <div className="summary-header">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <span>Change Password</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="offset-md-3 col-md-6 col-sm-12">
                                        <div className="row input-group" >
                                            <div className="col-sm-2 passinput" >
                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-9" >
                                                <TextField
                                                    hintText="Start Typing.."
                                                    floatingLabelText="Current Password"
                                                    type="password"
                                                    maxLength="15"
                                                    id="currentpassword"
                                                    name="oldPassword"
                                                    className="input-width required"
                                                    onChange={this.onChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                />
                                            </div>
                                            <div className="col-sm-1" style={{ padding: "0px 0px" }}>
                                                <span toggle="#currentpassword" className="fa fa-fw fa-eye field-icon toggle-password" style={{marginTop:"45px",marginLeft:"-12px"}} ></span>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="row input-group" >
                                            <div className="col-sm-2 passinput" >
                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-8" >
                                                <TextField
                                                    hintText="Start Typing.."
                                                    floatingLabelText="New Password"
                                                    type="password"

                                                    maxLength="15"
                                                    name="newPassword"
                                                    className="input-width required"
                                                    onChange={this.handelepassword}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}

                                                    errorText={correctPassword ? null : "Please check help button"}
                                                />

                                            </div>
                                            <div className="col-sm-2 tooltip" style={{ top: "35px", right: "16px" }}>
                                                <i className="fa fa-question-circle" aria-hidden="true"></i>
                                                <span className="tooltiptext" style={{ fontSize: "12px",top:"-65px",left:"-100px" }} >Your Password must contain at least 8 characters including one number, one lowercase letter, one uppercase letter and a special character. As an example, Rainbow123! </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row input-group" >
                                            <div className="col-sm-2 passinput" >
                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-9" >
                                                <div className="row">
                                                    <div className="col-sm-10 " style={{ paddingRight: "0px" }}>
                                                        <TextField
                                                            hintText="Start Typing.."
                                                            floatingLabelText="Confirm New Password"
                                                            type="password"
                                                            id="loginpassword"
                                                            maxLength="15"
                                                            name="confirmPassword"
                                                            className="input-width required"
                                                            style={{ zIndex: "0" }}
                                                            onChange={this.onChange}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                        />
                                                    </div>
                                                    <div className="col-sm-2" style={{ padding: "0px 5px" }}>
                                                        <span toggle="#loginpassword" className="fa fa-fw fa-eye field-icon toggle-password" style={{ position: "relative", color: "#333", top: "45px" }}></span>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div className="offset-sm-3 col-sm-3">
                                        <RaisedButton
                                            label="Change"
                                            className="pull-right"
                                            // style={styles.button}
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleSubmit}
                                            style={{ marginTop: "10px" }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="tile box-shadow-style">
                                <div className="row">
                                    <div className="col-md-12" style={{ padding: "0px 30px" }}>
                                        <div className="summary-header">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <span>Change Secret Question</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="offset-md-3 col-md-6 col-sm-12">
                                        <div className="row input-group" >
                                            <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-8" >
                                                <TextField
                                                    hintText="Start Typing.."
                                                    floatingLabelText="Current Password"
                                                    type="password"
                                                    name="currentPassword"
                                                    id="oldPassword1"
                                                    maxLength="15"
                                                    className="input-width required"
                                                    onChange={this.onChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                />
                                            </div>
                                            <div className="col-sm-1" style={{ padding: "0px 0px" }}>
                                                <span toggle="#oldPassword1" className="fa fa-fw fa-eye field-icon toggle-password" style={{marginTop:"45px",marginLeft:"-12px"}} ></span>
                                            </div>
                                        </div>


                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="row input-group" >
                                            <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-question-circle" aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-10" >
                                                <SelectField
                                                    value={this.state.value}

                                                    onChange={this.handleSelect}
                                                    name="secretQuestionCode"

                                                    floatingLabelText="Secret Question"
                                                    className="input-width required"
                                                >
                                                    {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                        <MenuItem value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                                    ) : <div>Select Question</div>}
                                                </SelectField>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row input-group" >
                                            <div className="col-sm-2 input-icon" style={{padding:"6px 0px 0px 40px"}} >
                                                <img style={{ bottom: "-36px", position:"relative" }} src={answerimg} alt="" />
                                            </div>
                                            <div className="col-sm-10" >
                                                <TextField
                                                     hintText={(this.state.value === "DOB") ? "DD/MM/YYYY" : "Start Typing.."}
                                                    floatingLabelText="Secret Answer"
                                                    type="text"
                                                    name="secretAnswer"
                                                    maxLength="50"
                                                    className="input-width required"
                                                    onChange={this.onChangeSecAns}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    errorText={correctDob ? null : "Enter correct format"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="offset-sm-3 col-sm-3">
                                        <RaisedButton
                                            label="Change"
                                            className="pull-right"
                                            // style={styles.button}
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.changeSecretQuestion.bind(this)}
                                            style={{ marginTop: "10px" }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>}
                </div>

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);


// WEBPACK FOOTER //
// ./src/components/myprofile/changepassword.jsx